import { SidebarItem } from '../../interfaces';
import { Roles } from './roles';

export const COASSESS_MENU_ITEMS: SidebarItem[] = [
  {
    items: [
      {
        label: 'Dynamic Dashboard',
        icon: 'fa-solid fa-table-cells-large',
        roles: [Roles.Administrator, Roles.CaseManager],
        items: [
          {
            label: 'Provider Utilization',
            icon: 'bullet bullet-dot',
            routerLink: ['/provider-utilization'],
          }
        ],
      },
    ],
  },
  {
    items: [
      {
        label: 'Hospitalization Management',
        icon: 'fas fa-cogs',
        roles: [
          Roles.Administrator,
          Roles.CaseManager,
          Roles.Investigator,
          Roles.Guest,
        ],
        items: [
          {
            label: 'Hospital Admissions',
            icon: 'bullet bullet-dot',
            roles: [Roles.Administrator],
            routerLink: ['/hospital-admissions'],
          },
          {
            label: 'Claims',
            icon: 'bullet bullet-dot',
            routerLink: ['/case-table'],
          },
        ],
      },
    ],
  },
  {
    items: [
      {
        label: 'Reports',
        icon: 'fas fa-chart-bar',
        routerLink: ['/reports'],
        roles: [
          Roles.Administrator,
          Roles.CaseManager,
          Roles.Investigator,
          Roles.Guest,
        ],
      },
    ],
  },
  {
    items: [
      {
        label: 'Network Analysis',
        icon: 'fa-solid fa-circle-nodes',
        routerLink: ['/network-analysis'],
        roles: [
          Roles.Administrator,
          Roles.CaseManager,
          Roles.Investigator,
          Roles.Guest,
        ],
      },
    ],
  },
  {
    items: [
      {
        label: 'Settings',
        icon: 'fas fa-edit',
        routerLink: ['**'],
        roles: [Roles.Administrator],
        items: [
          {
            label: 'Manage Users',
            icon: 'bullet bullet-dot',
            routerLink: ['/manage-users'],
          },
        ],
      },
    ],
  },
  {
    items: [
      {
        label: 'About',
        icon: 'fas fa-circle-info',
        routerLink: ['/', { outlets: { modal: ['about-page'] } }],
        roles: [
          Roles.Administrator,
          Roles.CaseManager,
          Roles.Investigator,
          Roles.Guest,
        ],
      },
    ],
  },
];
